import React, {Component} from 'react';
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import {request} from "../../util/APIUtils";
import Table from "../../components/Table/Table";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import {API_BASE_URL} from "../../constants";
import Alert from "react-s-alert";
import LoadingIndicator from "../../common/LoadingIndicator";
import {Button, Dropdown, Menu} from 'antd';
import Icon from "antd/es/icon";
import "./PharmacyList.css";
import PharmacyForm from "./PharmacyForm";
import PharmacyDeleteModal from "./PharmacyDeleteModal";

class PharmacyList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            pharmacies: [],
            pharmaciesRegionName: [],
            isModalVisible: false,
            pharmacy: null,
            error: null,
            loading: false,
            page: 0,
            currentPage: 1,
            pageSize: 10,

            note: true,
            add: false,
            currentUser:[],
            userId: null,
            selectedPharmacy: null,
            selectedItem: null,
            branches: null,
            roles: null,
            totalIdList: [],
            debtList: [],
            cities: [],
            searching: false,
            searchQuery: undefined,
            total: 0,
            size: 10,
            // manual: false,
            isEditModalOpen: false,
            addNoteModal: false,
            addIncomingModal: false,
            addTransferModal: false,
            addDeleteModal: false,
            mode: this.props.location.mode,
            action: '',
            isLoading: false,
        };
        this.cancelPharmacyCreation = this.cancelPharmacyCreation.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.addNew = this.addNew.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleMenuClick = this.handleMenuClick.bind(this);
        this.handleRegionButtonClick = this.handleRegionButtonClick.bind(this);
        this.fetchPharmacies = this.fetchPharmacies.bind(this);
    }

    componentDidMount() {
        this.setState({cities: this.props.cities},
            () => this.fetchPharmacies());
    }

    componentDidUpdate(prevProps) {
        if (prevProps.cities !== this.props.cities) {
            this.setState({ cities: this.props.cities });
        }
    }

    fetchPharmacies(accessor, direction, page, size) {
        const self = this;

        const safePage =
            typeof page === "number"
                ? page
                : (self.state.page !== undefined ? self.state.page : 0);

        const safeSize =
            typeof size === "number"
                ? size
                : (self.state.size !== undefined ? self.state.size : 10);

        const sortStr = accessor
            ? `&sort=${accessor},${direction}`
            : "&sort=id,asc";

        const searchQuery = self.state.searchQuery
            ? `&${self.state.searchQuery}`
            : "";

        const url =
            `${API_BASE_URL}/pharmacies/allPharmacy` +
            `?page=${safePage}&size=${safeSize}` +
            sortStr +
            searchQuery;

        request({ url, method: "get" })
            .then(response => {
                const { content, totalPages } = response.data;

                // Hiç kayıt yoksa recursive çağrı YAPMA
                if (totalPages === 0) {
                    self.setState({
                        pharmacies: [],
                        loading: false
                    });
                    return;
                }

                // Sayfa boş ama önceki sayfa varsa
                if (content.length === 0 && safePage > 0 && safePage >= totalPages) {
                    return self.fetchPharmacies(
                        accessor,
                        direction,
                        totalPages - 1,
                        safeSize
                    );
                }

                self.setState({
                    page: safePage,
                    size: safeSize,
                    total: response.data.totalElements,
                    pharmacies: content,
                    pharmaciesRegionName: content.map(p => p.regionName),
                    totalIdList: content.map(p => p.id),
                    debtList: content.map(p => p.debt),
                    loading: false
                });
            })
    }

    handlePharmacyDelete = (id, name) => {
        const isConfirmed = window.confirm(`"${name}" Üyesini silmek istediğinizden emin misiniz?`);

        if (isConfirmed) {
            const token = localStorage.getItem("accessToken");
            const apiUrl = API_BASE_URL + `/pharmacies/${id}`;

            fetch(apiUrl, {
                method: "DELETE",
                headers: {
                    Authorization: "Bearer " + token,
                },
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    this.setState((prevState) => ({
                        pharmacies: prevState.pharmacies.filter((pharmacy) => pharmacy.id !== id),
                    }));
                })
                .catch((error) => {
                    console.error("There was a problem with the fetch operation:", error.message);
                });
        }
    };

    handleEditPharmacy = (editedPharmacy) => {
        const token = localStorage.getItem("accessToken");
        const url = API_BASE_URL + `/pharmacies/${editedPharmacy.id}`;
        let data = editedPharmacy
        let message;
        const params = {
            url: url,
            method: "PUT",
            headers: {
                Authorization: "Bearer " + token,
                "Content-Type": "application/json",
            },
            data: data,
        };

        request(params)
            .then((response) => {
                Alert.success(
                    message, {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 5000
                    });
                if (response.status === 200) {
                    message = "Eczane başarıyla güncellendi!";
                    this.fetchPharmacies(this.state.page, this.state.pageSize);
                    this.setState({ isModalVisible: false });
                } else {
                    console.error("Unexpected response status:", response.status);
                    message = "Eczane güncellenemedi. Lütfen tekrar deneyin.";
                }
            })
            .catch((error) => {
                console.error("Eczane güncellenirken bir hata oluştu:", error);
                message = "Eczane güncellenirken bir hata oluştu. Lütfen tekrar deneyin.";
            });
    };

    handleLogout() {
        this.props.handleLogout();
    }
    cancelPharmacyCreation() {
        this.setState({
            isEditModalOpen: false,
            addDeleteModal: false,
            add:false,
        })
        this.fetchPharmacies(this.state.accessor, this.state.direction, this.state.page, this.state.pageSize);
    }

    handleEdit(item) {
        this.setState({
            selectedPharmacy: item,
            isEditModalOpen: true,
        })
    }
    handleDelete(item) {
        this.setState({
            selectedPharmacy: item,
            addDeleteModal: true
        })
    }

    addNew(item) {
        this.setState({
            selectedPharmacy: null,
            isEditModalOpen: true,
            add:true
        })
    }
    handleSearch(searchQuery, fromForm) {
        let page = 0;
        if (fromForm) {
            page = this.state.page;
        }
        this.setState({
            searchQuery,
            searching: true,
        }, () => this.fetchPharmacies(this.state.accessor, this.state.direction, page, this.state.size))
    }

    handleMenuClick(e) {
        let self = this;
        if (e.key === '1') {
            this.handleEdit(self.state.selectedItem);
        } else if (e.key === '2') {
            this.handleDelete(self.state.selectedItem);
        }
    }
    handleRegionButtonClick = () => {
        this.props.history.push("/regions");
    };

    render() {
        let self = this;
        let pharmaciesRegionName = this.state.pharmaciesRegionName
        const menu = (
            <Menu onClick={self.handleMenuClick}>
                {
                    self.state.selectedItem &&
                    <Menu.Item key="1">
                        Eczane Düzenle
                    </Menu.Item>
                }
                {
                    self.state.selectedItem &&
                    <Menu.Item key="2">
                        Eczane Sil
                    </Menu.Item>
                }
            </Menu>
        );
        const columns = [
            {
                Header: "Eczane Adı",
                accessor: "name",
            },
            {
                Header: "Telefon",
                accessor: "phone",
                Cell: item => (
                    <label style={{width:"100px"}}>{item.phone || ""}</label>
                )
            },
            {
                Header: "Adres",
                accessor: "location",

            },
            // {
            //     Header: "İlçe",
            //     accessor: "district",
            //
            // },
            {
                Header: "Bölge",
                accessor: "regionName",
                Cell: item => (
                    <label>{item.region && item.region.regionName}</label>
                )
            },

            {
                Header: "İşlemler",
                accessor: "",
                sortable: false,
                Cell: item => (
                    <div>
                        <Dropdown overlay={menu} trigger='click' onClick={() => self.setState({selectedItem: item})}>
                            <Button style={{
                                background: '#3b6b96',
                                height: '30px',
                                width: '100px',
                                color: 'white',
                                borderRadius: '0.375em',
                                fontSize: "12px",
                            }}>
                                Seçiniz<Icon type="down"/>
                            </Button>
                        </Dropdown>
                    </div>
                )
            }

        ];

        const fields = [
            {
                label: "Eczane Adı",
                accessor: "name",
                type: "text",
                operator: "=",
            },
            {
                label: "Adres",
                accessor: "location",
                type: "text",
                operator: "=",
            },
           /* {
               label: "Bölge",
                accessor: "regionName",
                type: "text",
                operator: "=",
                selectData: pharmaciesRegionName

            },
            */
            // {
            //     label: "İlçe",
            //     accessor: "district",
            //     type: "text",
            //     operator: "=",
            //     // selectData: branchSelectdata,
            // },
            // {
            //     label: "İl",
            //     accessor: "this.state.pharmacies.region.regionName",
            //     type: "text",
            //     operator: "=",
            //     // selectData: citySelectdata,
            // },

        ];

        return (
            <div className="row baseBackground">
                {
                    (this.state.isLoading) &&
                    <div className="loader">
                        <LoadingIndicator/>
                    </div>
                }
                <div className="col-md-12 satirBasi">
                    <div className="card-header ">
                        <h4 className="card-title">Eczane Düzenleme İşlemleri</h4>
                    </div>
                    <div className="card-body mt-1">
                        <div className=" ">
                            <div className="" style={{marginTop: '10px', marginBottom: '10px'}}>
                                <DetailedSearch
                                    fields={fields}
                                    loading={this.state.searching}
                                    onSearch={this.handleSearch}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <Table
                            loading={this.state.loading}
                            loadingText="Kayıtlar getiriliyor..."
                            content={this.state.pharmacies}
                            total={this.state.total}
                            page={this.state.page}
                            size={this.state.size}
                            options={["5", "10", "20", "50", "100"]}
                            columns={columns}
                            fetchData={this.fetchPharmacies}
                            style={{ width: "100%" }}
                        />
                    </div>
                    <div className="new-button-holder">
                        <button type="button" data-toggle="tooltip" data-placement="bottom"
                                title="Yeni Eczane Ekle" disabled={this.state.isLoading}
                                style={{
                                    background: 'linear-gradient(#2b93cd, #0a66b7)',
                                    height: '40px',
                                    width: '160px',
                                    float: 'right',
                                    marginRight: '30px',
                                    color: 'white',
                                    borderRadius: '0.375em',
                                    marginBottom:"5px",
                                }}
                                className="TekBtn add-new-member "
                                rel="tooltip"
                                onClick={() => this.addNew(this.state.selectedItem)}>
                            YENİ ECZANE EKLE
                        </button>
                        <button type="button" data-toggle="tooltip" data-placement="bottom"
                                title="Bölgeler" disabled={this.state.isLoading}
                                style={{
                                    background: 'linear-gradient(rgba(159, 208, 55, 0.6), rgb(159, 208, 55))',
                                    height: '40px',
                                    width: '160px',
                                    float: 'right',
                                    marginRight: '30px',
                                    color: 'white',
                                    borderRadius: '0.375em',
                                }}
                                rel="tooltip" className="TekBtn regions "

                                onClick={this.handleRegionButtonClick}>
                            BÖLGELER
                        </button>
                    </div>
                </div>
                <Modal isOpen={this.state.isEditModalOpen} size="xl" className="ust pharmacy-edit-modal">
                    <ModalHeader toggle={this.cancelPharmacyCreation}>
                        {this.state.add
                            ?
                            'Yeni Eczane Ekleme'
                            :
                            'Eczane Düzenleme'
                        }
                    </ModalHeader>
                    <ModalBody className="pharmacy-edit-modal-body">
                        <PharmacyForm
                            cancelProcess={this.cancelPharmacyCreation}
                            selectedPharmacy={this.state.selectedPharmacy}
                            cities={this.state.cities}
                            currentUser={this.props.currentUser}
                            mode={this.state.mode}
                            module={this.props.name}
                            handleSearch={this.handleSearch}
                            searchQuery={this.state.searchQuery}
                            pharmacy={this.state.pharmacy}
                            handleLogout={this.handleLogout}
                            onSave={this.handleEditPharmacy}
                            onClose={() => this.setState({ isEditModalOpen: false, pharmacy: null })}
                        />
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.addDeleteModal} size="lg" className="ust" zIndex={1060}>
                    <ModalHeader toggle={this.cancelPharmacyCreation}>
                        Eczane Silme
                    </ModalHeader>
                    <ModalBody style={{'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}}>
                        <PharmacyDeleteModal
                            cancelProcess={this.cancelPharmacyCreation}
                            selectedPharmacy={this.state.selectedPharmacy}
                            handleLogout={this.handleLogout}
                        />
                    </ModalBody>
                </Modal>
            </div>
        )
    }
}

export default PharmacyList;



// WEBPACK FOOTER //
// ./src/page/pharmacyList/PharmacyList.js